.divider {
  margin: -5px 0 10px;
}

.sectionTitle {
  margin-top: 15px;
  font-weight: bold !important;
}
